import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import PlLineTitle from "./PlLineTitle"
import PlSeparator from "./PlSeparator"
import { moment, scale, thousandSeparator } from "utils"

const PlShiftPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth
  } = props

  const {
    fullName,
    startingCash,
    startAt,
    endAt,
    paidIns,
    paidOuts,
    taxesAndCharges,
    refund,
    discounts,
    payments,
    actualCashAmount
  } = printData

  const [t] = useTranslation()

  const styles =
    templateType === "thermal" ? stylesThermal(printerWidth) : stylesOther

  const cashTypes = Object.keys(payments)

  const totalTendered =
    cashTypes.reduce((t, cashType) => t += payments[cashType], 0)

  const totalPaidIns =
    paidIns.reduce((t, paidIn) => t += paidIn.amount, 0)

  const totalPaidOuts =
    paidOuts.reduce((t, paidOut) => t += paidOut.amount, 0)

  const expectedCashAmount =
    payments["cash"] +
    startingCash +
    totalPaidIns -
    totalPaidOuts -
    refund

  const grossSales =
    totalTendered - taxesAndCharges + discounts - refund

  const netSales =
    totalTendered - taxesAndCharges - refund

  return (
    <Fragment>
      <div style={styles["container"]}>
        <div style={styles["header"]}>
          ({t("پایان_شیفت")})
        </div>

        <PlLineTitle
          title="اطلاعات_صندوقدار"
          templateType={templateType}
        />

        <div style={styles["text"]}>
          {t("نام_صندوقدار")}:{" "}
          <b style={styles["bold"]}>
            {fullName}
          </b>
        </div>

        <PlLineTitle
          title={t("زمان_شیفت")}
          templateType={templateType}
        />

        <div style={styles["text"]}>
          {t("شروع_شیفت")}:{" "}
          <b style={styles["bold"]} >
            {moment(startAt).format("jYYYY/jMM/jDD - HH:mm")}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("پایان_شیفت")}:{" "}
          <b style={styles["bold"]} >
            {moment(endAt).format("jYYYY/jMM/jDD - HH:mm")}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("پول_اولیه_صندوق")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(startingCash)}
          </b>
        </div>

        {cashTypes.map(cashType => (
          <div key={cashType} style={styles["text"]}>
            {cashType}:{" "}
            <b style={styles["bold"]} >
              {thousandSeparator(payments[cashType])}
            </b>
          </div>
        ))}

        <div style={styles["text"]}>
          {t("پول_مرجوعی")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(refund)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("تخفیف_ها")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(discounts)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("مالیات_و_خدمات")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(taxesAndCharges)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("واریز_به_صندوق")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(totalPaidIns)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("برداشت_از_صندوق")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(totalPaidOuts)}
          </b>
        </div>

        <div style={styles["separator"]} />

        <div style={styles["text"]}>
          {t("میزان_پول_در_صندوق")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(expectedCashAmount)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("مقدار_پول_مورد_مناقصه")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(totalTendered)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("مقدار_فروش")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(grossSales)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("میزان_سود")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(netSales)}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("میزان_پول_موجود")}:{" "}
          <b style={styles["bold"]} >
            {thousandSeparator(actualCashAmount)}
          </b>
        </div>
      </div>

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  header: {
    textAlign: "center"
  },
  text: {
  }
})

const stylesOther = {
  container: {
    marginRight: "4px",
    fontSize: "11px"
  },

  header: {
    textAlign: "center"
  }
}

export default PlShiftPrintTemplate